module.exports = __webpack_public_path__ + "img/banner1.dfbab7dd.png";